import React from 'react';
import { PatternFormat } from 'react-number-format';

const Phone = props => {
  const { value, valueChange, disabled, required } = props;

  let _format;
  if (String(value).length < 11) {
    _format = "(##) ####-#####"
  }
  else if (String(value).length >= 11) {
    _format = "(##) # ####-####"
  }

  return (
    <PatternFormat
      data-required={required}
      data-required-valid={required && !!value}
      disabled={disabled}
      placeholder="(**) ****-****"
      format={_format}
      value={!value ? "" : value}
      onValueChange={e => {
        valueChange(parseFloat(e.value))
      }}
      {...props}
    />
  )
}

export default Phone